import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface AuthenticatePortfolioProps {
  text: string;
  buttonText: string;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  buttonClassName?: string;
}

const AuthenticatePortfolio: FC<AuthenticatePortfolioProps> = ({
  text,
  buttonText,
  onClick,
  className,
  buttonClassName,
}) => {
  return (
    <div
      className={twMerge(
        "z-1 absolute inset-0 flex h-[172px] items-center justify-center bg-[rgba(0,0,0,0.7)] md:h-[230px]",
        className,
      )}
    >
      <div className="rounded-xlpx-6 pointer-events-auto max-w-[454px] py-5 text-center text-white max-md:max-w-[260px]">
        <i className="icomoon mx-auto mb-0 block h-[30px] w-[19.59px] pb-0 leading-none before:mb-0 before:block before:h-[30px] before:w-[19.59px] before:pb-0 before:leading-none before:content-['\e95D']" />
        <div className="my-3 text-[12px] md:text-[14px]">{text}</div>
        <button
          type="button"
          className={twMerge(
            "inline-flex h-[42px] min-w-[160px] cursor-pointer items-center justify-center rounded-[200px] bg-gradient-to-r from-[#FF6700] to-[#FF8900] px-6 py-3 text-sm font-medium leading-[18px] text-white max-md:h-[24px] max-md:min-w-[67px] max-md:px-3 max-md:py-1 max-md:text-xs",
            buttonClassName,
          )}
          onClick={onClick}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default AuthenticatePortfolio;
